module.exports = __webpack_public_path__ + "static/img/sc.aec1be20.svg";